import PortfolioPages from './components/PortfolioPages';

function App() {
	return (
		<PortfolioPages/>
	);
}

export default App;